<template>
  <!-- <BacktoPage path="/TaxMasterTableview"></BacktoPage> -->

  <b-container class="overall-bg pb-0">
    <b-row>
      <b-col>
        <BacktoPage :goback="$router.back"></BacktoPage>
        <b-row> </b-row>
      </b-col>
    </b-row>
  </b-container>
  <section v-if="items.length !== 0" class="details_collapse">
    <DetailsBanner :details="data" :loading="loading" class="my-4" />
  </section>

  <b-container class="form-white-bg">
    <div class="field" v-if="uploadedTableList.length != 0">
      <label class="mb-0">{{ $t("PurchaseRequest.QuotationFile") }}</label>
    </div>
    <b-row>
      <b-col lg="3" md="4" sm="6" cols="12" class="d-flex mb-3" v-for="item in uploadedTableList">
        <div class="fileuploadcard my-2" :title="item.fileName">
          <div>
            <p class="filenametxt">{{ item.fileName }}</p>
            <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
              view
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-between align-items-center">
      <p class="common-heading1 mb-4">Items part of the request</p>
      <div>
        <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
      </div>
    </div>
    <TabView class="tabview-custom" ref="tabview4">
      <TabPanel>
        <template #header>
          <i class="pi pi-file-edit pe-3"></i>
          <span>Request Details
            <Badge :value="items.length" severity="warning"></Badge>
          </span>
        </template>

        <b-row class="mt-2" v-if="ObjCamp.IsCamp && ObjCamp.CampDetailCard">
          <p class="fn14 fw500">Camp Details</p>
          <b-col lg="6" md="6" class="campdetailscard">
            <b-row>
              <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                <p class="light-txt">Institute name:</p>
                <p class="fn14 fw500">{{ ObjCamp.InstituteName }}</p>
              </b-col>
              <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                <p class="light-txt">Camp date:</p>
                <p class="fn14 fw500">{{ ObjCamp.FormattedCampDate }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="8" md="8" class="d-flex align-items-center gap-2 py-2">
                <p class="light-txt">Camp type:</p>
                <p class="fn14 fw500">{{ ObjCamp.CampType }}</p>
              </b-col>
              <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                <p class="light-txt">Expected IP:</p>
                <p class="fn14 fw500">{{ ObjCamp.ExpectedIP }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                <p class="light-txt">Camp name:</p>
                <p class="fn14 fw500">{{ ObjCamp.CampName }}</p>
              </b-col>
              <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                <p class="light-txt">Expected OP:</p>
                <p class="fn14 fw500">{{ ObjCamp.ExpectedOP }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0" eheader="OutBound Request Items" econtent="OutBound Request Items"
              eimg="/src/assets/Img/icons/request.svg" @createNew="" :createline="false" />

            <Tableview v-model:value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id"
              :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers"
              :globalFilterFields="globalFilterFields" :filters="filters" :seriaNlumber="true">
              <template v-slot:Add> </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsConfirmEdit(data)" />
                  <DeleteIcon @click="IsConfirmDel(data)" />
                </span>
              </template>
              <template v-slot:Brandmodelsize="{ data }">
                <p v-if="
                  data.BrandName == null &&
                  data.ModelNumberName == null &&
                  data.SizeName == null
                ">
                  {{ "-" }}
                </p>
                <p v-else>
                  {{ data.BrandName != null ? data.BrandName : "-" }} /
                  {{
                    data.ModelNumberName != null ? data.ModelNumberName : "-"
                  }}
                  /
                  {{ data.SizeName != null ? data.SizeName : "-" }}
                </p>
              </template>
            </Tableview>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0" eheader="OutBound Request Items" econtent="OutBound Request Items"
              eimg="/src/assets/Img/icons/request.svg" @createNew="" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center gap-1">
                    <p class="light-name">{{ item["ItemCode"] }} /</p>
                    <p class="light-name">{{ item["HSNCode"] }}</p>
                    <p class="light-name" v-if="item['IssueCode']">
                      / {{ item["IssueCode"] }}
                    </p>
                  </div>
                  <p class="name">{{ item["Itemname1"] }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Requested Quantity :</p>
                    <p class="small-name">
                      {{ item["ItemQuantity"] ? item["ItemQuantity"] : "0" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Received Quantity :</p>
                    <p class="small-name">
                      {{ item["IssueQty"] ? item["IssueQty"] : "0" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Returns :</p>
                    <p class="small-name">
                      {{ item["Returns"] ? item["Returns"] : "0" }}
                    </p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>

        <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
          :content="$t('confirmation.editcontent')" />
        <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
        <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
        <!-- </div> -->
      </TabPanel>
      <TabPanel>
        <template #header>
          <i class="pi pi-box pe-3"></i>
          <span>Issue Details
          </span>
        </template>

        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="IssueDetailsHeaders" :loading="IssueTableLoader" />
          <div v-if="!IssueTableLoader">
            <MasterEmpty v-if="issueDetailData.length === 0" eheader="Issue Details" econtent="Issue Details"
              eimg="/src/assets/Img/icons/request.svg" @createNew="" :createline="false" />

            <Tableview v-model:value="issueDetailData" :paginator="true" class="p-datatable-gridlines" :rows="10"
              dataKey="id" :rowHover="true" filterDisplay="menu" :loading="IssueTableLoader" responsiveLayout="scroll"
              :columns="IssueDetailsHeaders" :globalFilterFields="globalFilterFields" :filters="filters"
              :seriaNlumber="true">
              <template v-slot:Itemname1="{ data }">
                <span>
                  {{ data.Itemname1 }}
                </span>
                <span class="spantxt">
                  {{ data.BarCode }}
                </span>
              </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsConfirmEdit(data)" />
                  <DeleteIcon @click="IsConfirmDel(data)" />
                </span>
              </template>
              <template v-slot:Brandmodelsize="{ data }">
                <p v-if="
                  data.BrandName == null &&
                  data.ModelNumberName == null &&
                  data.SizeName == null
                ">
                  {{ "-" }}
                </p>
                <p v-else>
                  {{ data.BrandName != null ? data.BrandName : "-" }} /
                  {{
                    data.ModelNumberName != null ? data.ModelNumberName : "-"
                  }}
                  /
                  {{ data.SizeName != null ? data.SizeName : "-" }}
                </p>
              </template>
            </Tableview>
          </div>
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <i class="pi pi-history pe-3"></i>
          <span>Logs
            <Badge :value="0" severity="warning"></Badge>
          </span>
        </template>
        <Log v-for="item in headers" />
      </TabPanel>
    </TabView>
  </b-container>

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted, computed } from "vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/NormalTable.vue";
import Log from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import commonService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useRoute } from "vue-router";
import WithoutStockAffectService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useRouter } from "vue-router";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import RequestFlowChart from "../../../../../../../components/Chart/RequestFlowChart.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import DetailsBanner from "../../../../../../../modules/Inventory/components/Transaction/detailsbanner.vue";
import { useI18n } from "vue-i18n";
import StockOut from "../../../../../../../modules/Inventory/pages/Transaction/StockOut/StockOut.vue";
import moment from "moment";
import StockWOFileUploadServices from "../../../../../../../modules/Inventory/Service/StockWOFileUploadService";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Tableview,
    Log,
    Loader,
    RequestFlowChart,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    DetailsBanner,
    TextField,
    CrystalReportPrintPopUp
  },
  setup() {
    const routes = useRoute();
    let stocktransid = routes.query.stocktransid;
    let status = routes.query.status ?? 0;
    const dataEdit = ref({});
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const router = useRouter();
    let requestid = ref("");

    let loading = ref(false);
    let IssueTableLoader = ref(false);
    let items = ref([]);
    let issueDetailData = ref([]);

    const windowWidth = ref(window.innerWidth);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    onMounted(async () => {
      window.addEventListener("resize", handleResize);
      await IsShow();
      await LoadIssueDetails();
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const menu = ref();
    const action = ref([
      {
        items: [
          {
            label: "Close the request",
          },

        ],
      },
    ]);

    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      Status: "",
      RequesterName: "",
      RequestCategory: "",
      Remarks: "",
      MarkasUrgent: ref(),
      BranchId: 0,
      tostoreid: "",
      id: ref(),
      date: ref(),
    });

    let ObjCamp: any = ref({
      CampDetailCard: false,
      IsCamp: false,
      CampId: ref(),
      InstituteName: "",
      CampName: "",
      CampType: "",
      CampDate: "",
      FormattedCampDate: "",
      ExpectedIP: "",
      ExpectedOP: "",
    });

    const toggle = (event: MouseEvent) => {
      menu.value.toggle(event);
    };

    const headers = [
      {
        header: t("storetabdetails.outboundrequestdetails.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft1",
        bodyclass: "boldclass",
      },
      // {
      //   header: "HSN",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.outboundrequestdetails.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1 newcolumnfreezeleft3",
      },
      // {
      //   header: t("storetabdetails.outboundrequestdetails.IssueId"),
      //   field: "IssueCode",
      //   bodyclass: "bluecolor",
      // },
      {
        header: t("storetabdetails.outboundrequestdetails.UOM"),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.ReqQty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.ReceivedQty"),
        field: "IssueQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Consumed Quantity",
      //   field: "ItemQuantity",
      // },
      // {
      //   header: "Available Quantity",
      //   field: "StockInHand",
      // },
      {
        header: t("storetabdetails.outboundrequestdetails.ReturnQty"),
        field: "ReturnQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.DeletedReason"),
        field: "DeletedReason",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Total Value",
      //   field: "unit rate",
      // },
      // { field: "action", header: "Action", slot: "action",
      // frozencolumn: true, sortable: false },
    ];



    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };


    const IssueDetailsHeaders = [
      {
        header: t("storetabdetails.outboundrequestdetails.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft1",
        bodyclass: "boldclass",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.Name"),
        field: "Itemname1",
        slot: "Itemname1",
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1 newcolumnfreezeleft3",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.IssueId"),
        field: "IssueCode",
        bodyclass: "bluecolor",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.UOM"),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: t("storetabdetails.outboundrequestdetails.ReqQty"),
      //   field: "ItemQuantity",
      //   bodyclass: "right_td",
      //   class: "smallwidth",
      // },
      // {
      //   header: t('storetabdetails.inboundrequestdetails.AvlQty'),
      //   field: "ToStoreStockInHand",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t("storetabdetails.outboundrequestdetails.ReceivedQty"),
        field: "IssueQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.ReturnQty"),
        field: "ReturnQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
    ];

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }
    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }
    function IsEdit(data) {
      debugger;
      router.push({
        name: "Createstore",
        query: {
          storeId: data.Id,
          storeType: data.StoreTypeId,
        },
      });
    }
    async function IsDelete(data) { }
    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const result = await WithoutStockAffectService.GetByStockWOTransId(
          stocktransid
        );
        items.value = result["result"];
        console.log(items.value);
        const totalIssueQty = computed(() => {
          return items.value.reduce(
            (sum, item: any) => sum + item.StockOutQty,
            0
          );
        });
        const addedItemIds = new Set();
        const totalItemQty = computed(() => {
          return items.value.reduce((sum, item: any) => {
            if (!addedItemIds.has(item.ItemId)) {
              addedItemIds.add(item.ItemId);
              return sum + item.ItemQuantity;
            }
            return sum;
          }, 0);
        });
        requestid.value = result["result"][0].DocNo;
        data.value.fromstr = result["result"][0].FromStoreName;
        data.value.tostr = result["result"][0].ToStoreName;
        data.value.fromstoreid = result["result"][0].FromStoreCode;
        data.value.tostoreid = result["result"][0].ToStoreCode;
        data.value.fromstatus = result["result"][0].FromStoreType;
        data.value.tostatus = result["result"][0].ToStoreType;
        data.value.Remarks = result["result"][0].Remarks;
        data.value.RequestCategory = result["result"][0].CategoryName;
        data.value.RequesterName = result["result"][0].CreatedByName;
        data.value.MarkasUrgent =
          result["result"][0].Remarkscheck == 1 ? true : false;
        data.value.fromcount = totalItemQty;
        data.value.tocount = totalIssueQty;
        data.value.id = result["result"][0].DocNo;
        data.value.Status = result["result"][0].Status;
        data.value.date = moment(result["result"][0].DocDate).format(
          "DD-MM-YYYY"
        );

        data.value.BranchId = result["result"][0].BranchId;

        if (result["result"][0].IsCamp) {
          ObjCamp.value.IsCamp = result["result"][0].IsCamp;
          ObjCamp.value.CampId = result["result"][0].CampId;
          ObjCamp.value.InstituteName = result["result"][0].InstituteName;
          ObjCamp.value.CampName = result["result"][0].CampName;
          ObjCamp.value.CampType = result["result"][0].CampType;
          ObjCamp.value.CampDate = result["result"][0].CampDate;
          ObjCamp.value.FormattedCampDate = moment(
            result["result"][0].CampDate,
            "MM/DD/YYYY hh:mm:ss A"
          ).format("DD/MM/YYYY");
          ObjCamp.value.ExpectedIP = result["result"][0].ExpectedIP;
          ObjCamp.value.ExpectedOP = result["result"][0].ExpectedOP;
          ObjCamp.value.CampDetailCard = true;
        }

        loading.value = false;
        const FileUploadresult =
          await StockWOFileUploadServices.getStockWOFileById(stocktransid);
        if (FileUploadresult["result"].length > 0) {
          for (let i = 0; i < FileUploadresult["result"].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] =
              FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
              (Fileobj["fileName"] =
                FileUploadresult["result"][i].FileName.split("/").pop()),
              (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
              (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
              (Fileobj["Id"] = FileUploadresult["result"][i].Id),
              uploadedTableList.value.push(Fileobj);
          }
        } else {
          uploadedTableList.value = [];
        }
      } catch { }
    }

    async function LoadIssueDetails() {
      debugger;
      try {
        IssueTableLoader.value = true;
        const result = await WithoutStockAffectService.GetIssueDetailsByRequestId(
          stocktransid
        );
        issueDetailData.value = result["result"];

        IssueTableLoader.value = false;

      } catch (error) { console.log(error); IssueTableLoader.value = false; }
    }

    let uploadedTableList: any = ref([]);
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 9,
      HeaderTitle: "OutBound Request",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = stocktransid;
      ParameterValues.value.BranchId = data.value.BranchId;
      ParameterValues.value.HospitalId = usersData.OrganizationId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      data,
      action,
      toggle,
      menu,
      globalFilterFields,
      items,
      issueDetailData,
      headers,
      IssueDetailsHeaders,
      filters,
      loading,
      IssueTableLoader,
      IsShow,
      IsConfirmEdit,
      dataEdit,
      Editmodel,
      deletepop,
      IsConfirmDel,
      closetrigger,
      IsEdit,
      Deletemodel,
      IsDelete,
      requestid,
      windowWidth,
      fileviewer,
      uploadedTableList,
      ObjCamp,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Print
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-icon {
  width: 30px;
}

.blackbg {
  background-color: #303030;
  height: 150px;
}

.Actionsbtn {
  background-color: #0a82ff !important;
  border: none !important;
  padding: 8px !important;
}

.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

// .itempart {}

// .logcard {
//     height: 30px;
// }</style>
